import script from "./SectionNewsGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionNewsGrid.vue?vue&type=script&setup=true&lang=js"

import "./SectionNewsGrid.vue?vue&type=style&index=0&id=50e89ecc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e89ecc"]])

export default __exports__